/**
 *
 * @module graphQlPersistedQuery
 *
 */

import Services from './../services/entry';

/**
 *
 * @class GraphQlPersistedQuery
 * @extends {SDK.Services.Content.GraphQlPersistedQuery}
 * @desc Represents a GraphQL persisted query.
 *
 */
export default class GraphQlPersistedQuery extends Services.Content.GraphQlPersistedQuery {}



// WEBPACK FOOTER //
// ./src/content/graphQlPersistedQuery.js